import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import Dashboard from '../pages/dashboard/Dashboard';
import Users from '../pages/users/Users';
import ChangePassword from '../pages/settings/change-password/ChangePassword';
import MainLayout from '../layouts/MainLayout';
import Province from '../pages/province/Province';
import City from '../pages/city/City';
import Facility from '../pages/facility/Facility';
import Voucher from '../pages/voucher/Voucher';
import CreateVoucher from '../pages/voucher/CreateVoucher';
import DetailVoucher from '../pages/voucher/DetailVoucher';
import Tenants from '../pages/tenants/Tenants';
import TenantDetail from '../pages/tenants/pages/TenantDetail';
import GlobalConfig from '../pages/global-config/GlobalConfig';
import PaymentMethod from '../pages/payment-method/PaymentMethod';
import Refund from '../pages/refund/Refund';
import Article from '../pages/article/Article';
import Withdrawl from '../pages/withdrawl/Withdrawl';
import CreateArticle from '../pages/article/CreateArticle';
import UpdateArticle from '../pages/article/UpdateArticle';
import WithdrawlDetail from '../pages/withdrawl/DetailWithdrawl';
import RefundDetail from '../pages/refund/DetailRefund';
import Income from '../pages/income/Income';
import Exepense from '../pages/expense/Expense';
import Cashflow from '../pages/cashflow/Cashflow';
import RefundReport from '../pages/refund/RefundReport';
import WithdrawlReport from '../pages/withdrawl/WithdrawlReport';
import Booking from '../pages/booking/Booking';
import BookingDetail from '../pages/booking/BookingDetail';
import { AuthContext } from '../context/AuthProvider';

// User Types
const REGULAR_ADMIN = 'REGULAR_ADMIN';
const MANAGEMENT_ADMIN = 'MANAGEMENT_ADMIN';
const SUPER_ADMIN = 'SUPER_ADMIN';

const ProtectedRoute = ({ requiredRoles, children }) => {
  const auth = useContext(AuthContext);
  const userType = auth[0]?.userProfile?.type;

  if (!requiredRoles.includes(userType)) {
    // If the role doesn't match, reroute to dashboard page
    return <Navigate to="/" replace />;
  }

  // If role matches, render the children (i.e., the protected route component)
  return children;
};

export default [
  {
    path: '',
    children: [
      {
        path: '',
        element: (
          <ProtectedRoute requiredRoles={[SUPER_ADMIN, MANAGEMENT_ADMIN, REGULAR_ADMIN]}>
            <MainLayout>
              <Dashboard />
            </MainLayout>
          </ProtectedRoute>
        )
      },
      {
        path: '/users',
        element: (
          <ProtectedRoute requiredRoles={[SUPER_ADMIN]}>
            <MainLayout>
              <Users />
            </MainLayout>
          </ProtectedRoute>
        )
      },
      {
        path: '/tenants',
        element: (
          <ProtectedRoute requiredRoles={[SUPER_ADMIN, MANAGEMENT_ADMIN, REGULAR_ADMIN]}>
            <MainLayout>
              <Tenants />
            </MainLayout>
          </ProtectedRoute>
        )
      },
      {
        path: '/tenants/detail/:id',
        element: (
          <ProtectedRoute requiredRoles={[SUPER_ADMIN, MANAGEMENT_ADMIN, REGULAR_ADMIN]}>
            <MainLayout>
              <TenantDetail />
            </MainLayout>
          </ProtectedRoute>
        )
      },
      {
        path: '/bookings',
        element: (
          <ProtectedRoute requiredRoles={[SUPER_ADMIN, MANAGEMENT_ADMIN]}>
            <MainLayout>
              <Booking />
            </MainLayout>
          </ProtectedRoute>
        )
      },
      {
        path: '/bookings/detail/:id',
        element: (
          <ProtectedRoute requiredRoles={[SUPER_ADMIN, MANAGEMENT_ADMIN]}>
            <MainLayout>
              <BookingDetail />
            </MainLayout>
          </ProtectedRoute>
        )
      },
      {
        path: '/province',
        element: (
          <ProtectedRoute requiredRoles={[SUPER_ADMIN]}>
            <MainLayout>
              <Province />
            </MainLayout>
          </ProtectedRoute>
        )
      },
      {
        path: '/city',
        element: (
          <ProtectedRoute requiredRoles={[SUPER_ADMIN]}>
            <MainLayout>
              <City />
            </MainLayout>
          </ProtectedRoute>
        )
      },
      {
        path: '/facility',
        element: (
          <ProtectedRoute requiredRoles={[SUPER_ADMIN]}>
            <MainLayout>
              <Facility />
            </MainLayout>
          </ProtectedRoute>
        )
      },
      {
        path: '/voucher',
        element: (
          <ProtectedRoute requiredRoles={[SUPER_ADMIN, MANAGEMENT_ADMIN, REGULAR_ADMIN]}>
            <MainLayout>
              <Voucher />
            </MainLayout>
          </ProtectedRoute>
        )
      },
      {
        path: '/voucher/create',
        element: (
          <ProtectedRoute requiredRoles={[SUPER_ADMIN, MANAGEMENT_ADMIN, REGULAR_ADMIN]}>
            <MainLayout>
              <CreateVoucher />
            </MainLayout>
          </ProtectedRoute>
        )
      },
      {
        path: '/voucher/detail/:id',
        element: (
          <ProtectedRoute requiredRoles={[SUPER_ADMIN, MANAGEMENT_ADMIN, REGULAR_ADMIN]}>
            <MainLayout>
              <DetailVoucher />
            </MainLayout>
          </ProtectedRoute>
        )
      },

      {
        path: '/global-config',
        element: (
          <ProtectedRoute requiredRoles={[SUPER_ADMIN, MANAGEMENT_ADMIN]}>
            <MainLayout>
              <GlobalConfig />
            </MainLayout>
          </ProtectedRoute>
        )
      },
      {
        path: '/payment-method',
        element: (
          <ProtectedRoute requiredRoles={[SUPER_ADMIN]}>
            <MainLayout>
              <PaymentMethod />
            </MainLayout>
          </ProtectedRoute>
        )
      },
      {
        path: '/refund',
        element: (
          <ProtectedRoute requiredRoles={[SUPER_ADMIN, MANAGEMENT_ADMIN, REGULAR_ADMIN]}>
            <MainLayout>
              <Refund />
            </MainLayout>
          </ProtectedRoute>
        )
      },
      {
        path: '/income',
        element: (
          <ProtectedRoute requiredRoles={[SUPER_ADMIN, MANAGEMENT_ADMIN]}>
            <MainLayout>
              <Income />
            </MainLayout>
          </ProtectedRoute>
        )
      },
      {
        path: '/expense',
        element: (
          <ProtectedRoute requiredRoles={[SUPER_ADMIN, MANAGEMENT_ADMIN]}>
            <MainLayout>
              <Exepense />
            </MainLayout>
          </ProtectedRoute>
        )
      },
      {
        path: '/cashflow',
        element: (
          <ProtectedRoute requiredRoles={[SUPER_ADMIN, MANAGEMENT_ADMIN]}>
            <MainLayout>
              <Cashflow />
            </MainLayout>
          </ProtectedRoute>
        )
      },
      {
        path: '/refund-report',
        element: (
          <ProtectedRoute requiredRoles={[SUPER_ADMIN, MANAGEMENT_ADMIN]}>
            <MainLayout>
              <RefundReport />
            </MainLayout>
          </ProtectedRoute>
        )
      },
      {
        path: '/withdrawl-report',
        element: (
          <ProtectedRoute requiredRoles={[SUPER_ADMIN, MANAGEMENT_ADMIN]}>
            <MainLayout>
              <WithdrawlReport />
            </MainLayout>
          </ProtectedRoute>
        )
      },
      {
        path: '/refund/detail/:id',
        element: (
          <ProtectedRoute requiredRoles={[SUPER_ADMIN, MANAGEMENT_ADMIN, REGULAR_ADMIN]}>
            <MainLayout>
              <RefundDetail />
            </MainLayout>
          </ProtectedRoute>
        )
      },
      {
        path: '/withdrawl',
        element: (
          <ProtectedRoute requiredRoles={[SUPER_ADMIN, MANAGEMENT_ADMIN, REGULAR_ADMIN]}>
            <MainLayout>
              <Withdrawl />
            </MainLayout>
          </ProtectedRoute>
        )
      },
      {
        path: '/withdrawl/detail/:id',
        element: (
          <ProtectedRoute requiredRoles={[SUPER_ADMIN, MANAGEMENT_ADMIN, REGULAR_ADMIN]}>
            <MainLayout>
              <WithdrawlDetail />
            </MainLayout>
          </ProtectedRoute>
        )
      },
      {
        path: '/article',
        element: (
          <ProtectedRoute requiredRoles={[SUPER_ADMIN, MANAGEMENT_ADMIN, REGULAR_ADMIN]}>
            <MainLayout>
              <Article />
            </MainLayout>
          </ProtectedRoute>
        )
      },
      {
        path: '/article/create',
        element: (
          <ProtectedRoute requiredRoles={[SUPER_ADMIN, MANAGEMENT_ADMIN, REGULAR_ADMIN]}>
            <MainLayout>
              <CreateArticle />
            </MainLayout>
          </ProtectedRoute>
        )
      },
      {
        path: '/article/details/:slug',
        element: (
          <ProtectedRoute requiredRoles={[SUPER_ADMIN, MANAGEMENT_ADMIN, REGULAR_ADMIN]}>
            <MainLayout>
              <UpdateArticle />
            </MainLayout>
          </ProtectedRoute>
        )
      },
      {
        path: '/settings',
        element: <Navigate to="/settings/change-password/" />
      },
      {
        path: '/settings/change-password',
        element: (
          <ProtectedRoute requiredRoles={[SUPER_ADMIN, MANAGEMENT_ADMIN, REGULAR_ADMIN]}>
            <MainLayout>
              <ChangePassword />
            </MainLayout>
          </ProtectedRoute>
        )
      }
    ]
  },
  {
    path: '*',
    element: <Navigate to="/" />
  }
];
